module.exports = __webpack_public_path__ + "static/media/btn-plus-1.893f175a.svg";